export default __webpack_public_path__ + "static/media/bg1_m.4f44c7bc.png";